module.exports = __webpack_public_path__ + "static/lafemme-dda145c10db73c373acaab577f35a1dc.jpg";